const DATE_STORAGE_KEYS = {
  START_DATE: 'rental_start_date',
  END_DATE: 'rental_end_date'
};

export const saveDatesToStorage = (startDate: string, endDate: string) => {
  try {
    localStorage.setItem(DATE_STORAGE_KEYS.START_DATE, startDate);
    localStorage.setItem(DATE_STORAGE_KEYS.END_DATE, endDate);
  } catch (error) {
    console.warn('Failed to save dates to localStorage:', error);
  }
};

export const loadDatesFromStorage = () => {
  try {
    const startDate = localStorage.getItem(DATE_STORAGE_KEYS.START_DATE);
    const endDate = localStorage.getItem(DATE_STORAGE_KEYS.END_DATE);
    return {
      startDate: startDate || '',
      endDate: endDate || ''
    };
  } catch (error) {
    console.warn('Failed to load dates from localStorage:', error);
    return { startDate: '', endDate: '' };
  }
};

export const clearDatesFromStorage = () => {
  try {
    localStorage.removeItem(DATE_STORAGE_KEYS.START_DATE);
    localStorage.removeItem(DATE_STORAGE_KEYS.END_DATE);
  } catch (error) {
    console.warn('Failed to clear dates from localStorage:', error);
  }
};
